var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flow-command',{attrs:{"name":_vm.command}},[_c('span',{staticClass:"material-icons-round",attrs:{"title":_vm.text || ""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }